import React, { createContext, useState } from 'react';
import { User } from '../../models';

type UserState = {
  user?: User;
  setUser: React.Dispatch<React.SetStateAction<User | undefined>>;
};

const defaultUserState: UserState = {
  user: undefined,
  setUser: () => {},
};

export const UserContext = createContext(defaultUserState);

export const UserContextProvider = (props: any) => {
  const [user, setUser] = useState(defaultUserState.user);

  return <UserContext.Provider value={{ user, setUser }}>{props.children}</UserContext.Provider>;
};
